<ngx-monaco-editor class="h-100" [options]="editorOptions" [(ngModel)]="code" (ngModelChange)="editorChange()"
    (onInit)="monacoInit($event)"></ngx-monaco-editor>